/* @flow */
import * as React from 'react';

const BookingInfo = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <path
      fill="#505FB4"
      d="M12,0 C5.373,0 0,5.373 0,12 C0,18.627 5.373,24 12,24 C18.627,24 24,18.627 24,12 C24,5.373 18.627,0 12,0 L12,0 Z"
    />
    <path
      fill="#FFFFFF"
      d="M13.426,16.297 C13.507,16.339 13.597,16.378 13.692,16.41 C13.79,16.444 13.891,16.467 13.996,16.481 L13.996,17 L10.151,17 L10.151,16.483 C10.256,16.473 10.36,16.462 10.461,16.447 C10.563,16.433 10.65,16.409 10.723,16.376 C10.853,16.318 10.944,16.237 10.997,16.131 C11.049,16.024 11.076,15.884 11.076,15.708 L11.076,11.573 C11.076,11.407 11.044,11.261 10.979,11.135 C10.915,11.01 10.833,10.909 10.736,10.833 C10.663,10.777 10.552,10.722 10.404,10.67 C10.256,10.617 10.121,10.585 10,10.571 L10,10.051 L12.982,9.866 L13.073,9.973 L13.073,15.615 C13.073,15.781 13.103,15.922 13.165,16.037 C13.225,16.153 13.313,16.24 13.426,16.297 Z M11.911,8.608 C11.582,8.608 11.299,8.481 11.063,8.228 C10.825,7.974 10.706,7.668 10.706,7.307 C10.706,6.947 10.825,6.64 11.063,6.384 C11.299,6.128 11.582,6 11.911,6 C12.24,6 12.522,6.128 12.757,6.384 C12.992,6.64 13.11,6.947 13.11,7.307 C13.11,7.668 12.99,7.974 12.754,8.228 C12.516,8.481 12.235,8.608 11.911,8.608 Z"
    />
  </svg>
);

export default BookingInfo;



// WEBPACK FOOTER //
// ./src/assets/images/icons/booking-info.js